import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Clock3, LogOut } from 'lucide-react'
import { AuthLayout } from '@/components/auth-card'
import { Button } from '@/components/ui/button'
import { IconTip } from '@/components/icon-tip'
export const Route = createFileRoute('/pending')({ component: Pending })
function Pending() {
  React.useEffect(() => {
    void fetch('/api/bootstrap', { credentials: 'same-origin' }).then((response) => {
      if (response.ok) location.replace('/')
      else if (response.status === 401) location.replace('/sign-in')
    }).catch(() => {})
  }, [])
  return <AuthLayout><div className="auth-icon"><Clock3 /></div><h1>Waiting for approval</h1><p>Your email is verified. Rich will need to approve your account before you can see family notes.</p><div className="flex justify-center"><IconTip label="Check approval"><Button variant="outline" size="icon" aria-label="Check approval" onClick={() => location.href = '/'}><Clock3 className="size-5" /></Button></IconTip><IconTip label="Sign out"><Button variant="outline" size="icon" aria-label="Sign out" onClick={() => fetch('/api/auth/sign-out', { method: 'POST' }).finally(() => { localStorage.removeItem('family-notes:last-approved-user'); location.href = '/sign-in' })}><LogOut className="size-5" /></Button></IconTip></div></AuthLayout>
}
